export default __webpack_public_path__ + "static/media/jobs-hero-shape-2.8bac7b64.svg";